// extracted by mini-css-extract-plugin
export default {"Loading":"loading_Loading__cvo9A"};